import { useState } from "react";
import { ConfirmModal } from "../../../modals/Confirm";

// Generic stop-coverage confirmation: works for a single branch or a
// restaurant-wide "stop all". `branches` is only used to render the affected
// branch names in the confirmation message.
const StopCoverageModal = ({ title, message, branches = [], confirmText, cancelText, onCancel, onConfirm }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const confirm = async () => {
    setLoading(true);
    setError("");
    try {
      await onConfirm();
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const branchList = branches.map((branch) => `- ${branch.name}`).join("\n");
  const fullMessage = branchList ? `${message}\n\n${branchList}` : message;

  return (
    <>
      {error && <div className="billing-modal-error">{error}</div>}
      <ConfirmModal
        title={title}
        message={fullMessage}
        confirmText={loading ? undefined : confirmText}
        cancelText={cancelText}
        onConfirm={confirm}
        onCancel={onCancel}
      />
    </>
  );
};

export default StopCoverageModal;
